const OBFUSCATION_SECRET = 34138468243;

export const toTitleCase = (str) => {
  return str.toLowerCase().replace(/(?:^|\s)\S/g, (char) => char.toUpperCase());
};

// const toTitleCase = (str) => {
//   return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
// };

export function obfuscate(str) {
  const encoded = [...str].map((c) => c.charCodeAt(0) ^ OBFUSCATION_SECRET).join(",");
  return btoa(encoded);
}

export function deobfuscate(str) {
  const decoded = atob(str)
    .split(",")
    .map((n) => String.fromCharCode(n ^ OBFUSCATION_SECRET))
    .join("");
  return decoded;
}
